export type DraftPreviewMode = "auto" | "on" | "off";

const STORAGE_KEY = "vb:studio:draftPreviewMode";
const subscribers = new Set<(mode: DraftPreviewMode) => void>();

export function getStoredDraftPreviewMode(): DraftPreviewMode {
  if (typeof window === "undefined") return "auto";
  const value = window.localStorage.getItem(STORAGE_KEY);
  if (value === "on" || value === "off") return value;
  return "auto";
}

export function setStoredDraftPreviewMode(mode: DraftPreviewMode): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, mode);
  for (const subscriber of subscribers) subscriber(mode);
}

export function subscribeDraftPreviewMode(
  cb: (mode: DraftPreviewMode) => void
): () => void {
  subscribers.add(cb);
  return () => subscribers.delete(cb);
}
